import Vue from "vue";
import VueRouter from "vue-router";

import store from "./../store";

import bg3Home from "../views/bg3/Home.vue";
import dos2Home from "../views/dos2/Home.vue";
import dosHome from "../views/dos/Home.vue";
import Onboarding from "../views/Onboarding.vue";
import Login from "../views/Login.vue";
import Merch from "../views/Merch.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "bg3",
    alias: "/bg3",
    component: bg3Home
  },
  {
    path: "/dos2",
    name: "dos2",
    component: dos2Home
  },
  {
    path: "/dos",
    name: "dos",
    component: dosHome
  },
  {
    path: "/onboarding",
    name: "Onboarding",
    component: Onboarding
  },
  {
    path: "/login",
    name: "Login",
    component: Login
  },
  {
    path: "/merch",
    name: "Merch",
    component: Merch
  },
  {
    path: "/account/connected",
    props: true,
    beforeEnter: (to, from, next) => {
      store.dispatch("setPlatform", to.query.platform);
      store.dispatch("setStep", 4);
      next({
        name: "Onboarding",
        params: { error: to.query.error }
      });

      // if (to.query.error) {
      //   next({
      //     name: "Onboarding",
      //     props: { error: "blad" }
      //   });
      // } else {
      //   next({
      //     name: "Onboarding"
      //   });
      // }
    }
  }
  // {
  //   path: "/about",
  //   name: "About",
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "../views/About.vue")
  // }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
